import React from 'react';
import { Redirect } from 'react-router-dom';
/**
 * Replaces the stock FOLIO welcome page on `/` (CZNA-1424, NK orpa/nove-autority#6).
 *
 * stripes-core renders `/` as `Front`, which is `<Pluggable type="frontpage">` around the
 * "Vítejte…" headline. This module registers as that plugin (`actsAs: plugin`,
 * `pluginType: frontpage` in package.json), so `/` sends the user straight to Authorities.
 * Every CZNA role is granted the Authorities app (CZNA-1425), so there is no role this
 * would strand on a route it cannot open.
 *
 * Only `/` itself is affected: a login through a deep link returns to that link, because
 * stripes-core never routes it through `/`.
 */
export var AUTHORITIES_HOME = '/czna-authorities';
var FrontPageRedirect = function () { return React.createElement(Redirect, { to: AUTHORITIES_HOME }); };
export default FrontPageRedirect;
